<template>
  <div>
    <v-tabs
      v-model="tab"
      fixed-tabs
      background-color="indigo"
      dark
      height="80px"
      show-arrows
      center-active
      slider-color="yellow"
    >
      <v-tab>
        Informasi
      </v-tab>  
      <!-- PENUNJUKAN LANGSUNG--> 
      <template v-if="paket.metodePemilihan === 'TLA' && paket.statusPelaksanaan != 'N'">
        <v-tab v-if="showTabFeature(1)" @click="moveTab(1)"> Undangan </v-tab>
        <v-tab v-if="showTabFeature(2)" @click="moveTab(2)"> Pemberian Penjelasan / Aanwizjing</v-tab>
        <v-tab v-if="showTabFeature(4)" @click="moveTab(4)"> Pembukaan dan Evaluasi Dokumen Penawaran </v-tab>
        <v-tab v-if="showTabFeature(5)" @click="moveTab(5)"> Undangan Klarifikasi dan Negosiasi Teknis dan Biaya </v-tab>
        <v-tab v-if="showTabFeature(6)" @click="moveTab(6)"> Hasil Klarifikasi dan Negosiasi Teknis dan Biaya </v-tab>
        <v-tab v-if="showTabFeature(7)" @click="moveTab(7)"> Berita Acara Klarifikasi dan Negosiasi </v-tab>
        <v-tab v-if="showTabFeature(8)" @click="moveTab(8)"> Penetapan Penyedia </v-tab>
        <v-tab v-if="showTabFeature(9)" @click="moveTab(9)"> Berita Acara Penunjukan Langsung </v-tab>
        <v-tab v-if="showTabFeature(10)" @click="moveTab(10)"> Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
        <v-tab v-if="showTabFeature(11)" @click="moveTab(11)"> Surat Perintah Kerja </v-tab>
        <v-tab v-if="showTabFeature(12)" @click="moveTab(12)"> Surat Perintah Mulai Kerja </v-tab>
      </template>
      <!-- PENGADAAN LANGSUNG -->
      <template v-else-if="paket.metodePemilihan === 'PLA' && paket.statusPelaksanaan != 'N'">
        <v-tab v-if="showTabFeature(1)" @click="moveTab(1)"> Undangan </v-tab>
        <v-tab v-if="showTabFeature(2)" @click="moveTab(2)"> Pemberian Penjelasan / Aanwizjing </v-tab>
        <v-tab v-if="showTabFeature(4)" @click="moveTab(4)"> Pembukaan dan Evaluasi Dokumen Penawaran </v-tab>
        <v-tab v-if="showTabFeature(5)" @click="moveTab(5)"> Pengumuman Hasil Evaluasi </v-tab>
        <v-tab v-if="showTabFeature(6)" @click="moveTab(6)"> Undangan Klarifikasi dan Negosiasi</v-tab>
        <v-tab v-if="showTabFeature(6)" @click="moveTab(6)"> Hasil Klarifikasi dan Negosiasi</v-tab>
        <v-tab v-if="showTabFeature(7)" @click="moveTab(7)"> Berita Acara Klarifikasi dan Negosiasi</v-tab>
        <v-tab v-if="showTabFeature(9)" @click="moveTab(9)"> Penandatanganan Kontrak (SPK) / Perjanjian </v-tab>
        <v-tab v-if="showTabFeature(10)" @click="moveTab(10)"> Penandatanganan Perintah Mulai Kerja (SPMK) / Surat Pesanan </v-tab>
      </template>
      <!-- TENDER -->
      <template v-else-if="paket.metodePemilihan === 'TEN' && paket.statusPelaksanaan != 'N'">
        <!-- Prakualifikasi -->
        <template v-if="paket.kualifikasi === 'P'">
          <v-tab v-if="includeTabProses.urut1" @click="moveTab(1)">Pengumuman Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut2" @click="moveTab(2)">Pendaftaran dan Pengambilan Dokumen Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut3" @click="moveTab(3)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut4" @click="moveTab(4)">Pemasukan Dokumen Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut5" @click="moveTab(5)">Pembukaan Dokumen Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut6" @click="moveTab(6)">Evaluasi Dokumen Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut7" @click="moveTab(7)">Undangan Pembuktian Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut9" @click="moveTab(9)">Penetapan Hasil Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut10" @click="moveTab(10)">Pengumuman Hasil Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut11" @click="moveTab(11)">Masa Sanggah Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut13" @click="moveTab(13)">Undangan Tender</v-tab>
          <v-tab v-if="includeTabProses.urut14" @click="moveTab(14)">Pendaftaran dan Pengambilan Dokumen Tender</v-tab>
          <v-tab v-if="includeTabProses.urut15" @click="moveTab(15)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut16" @click="moveTab(16)">Pemasukan Dokumen Penawaran Administrasi dan Teknis (File 1)</v-tab>
          <v-tab v-if="includeTabProses.urut17" @click="moveTab(17)">Pembukaan Dokumen Penawaran Administrasi dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut18" @click="moveTab(18)">Evaluasi Dokumen Penawaran Administrasi dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut19" @click="moveTab(19)">Undangan Pembuktian Dokumen Administrasi dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut20" @click="moveTab(20)">Pengumuman Hasil Evaluasi Administrasi dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut21" @click="moveTab(21)">Pemasukan Dokumen Penawaran Harga (File 2)</v-tab>
          <v-tab v-if="includeTabProses.urut22" @click="moveTab(22)">Pembukaan Dokumen Penawaran Harga</v-tab>
          <v-tab v-if="includeTabProses.urut23" @click="moveTab(23)">Evaluasi Dokumen Penawaran Harga</v-tab>
          <v-tab v-if="includeTabProses.urut24" @click="moveTab(24)">Penetapan Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut25" @click="moveTab(25)">Pengumuman Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut26" @click="moveTab(26)">Masa Sanggah</v-tab>
          <v-tab v-if="includeTabProses.urut27" @click="moveTab(27)">Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)</v-tab>
          <v-tab v-if="includeTabProses.urut29" @click="moveTab(29)">Undangan Klarifikasi Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut30" @click="moveTab(30)">Klarifikasi Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut30" @click="moveTab(30)">Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut31" @click="moveTab(31)">Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
          <v-tab @click="moveTab(32)">Penandatanganan Kontrak (SPK) / Perjanjian</v-tab>
          <v-tab @click="moveTab(34)">Penandatanganan Perintah Mulai Kerja (SPMK) / Surat Pesanan</v-tab>
        </template>
        <!-- Pascakualifikasi 1 File -->
        <template v-else-if="paket.kualifikasi === 'K'">
          <v-tab v-if="includeTabProses.urut1" @click="moveTab(1)">Pengumuman Tender</v-tab>
          <v-tab v-if="includeTabProses.urut2" @click="moveTab(2)">Pendaftaran dan Pengambilan Dokumen</v-tab>
          <v-tab v-if="includeTabProses.urut3" @click="moveTab(3)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut4" @click="moveTab(4)">Pemasukan Dokumen Penawaran</v-tab>
          <v-tab v-if="includeTabProses.urut5" @click="moveTab(5)">Pembukaan Dokumen Penawaran</v-tab>
          <v-tab v-if="includeTabProses.urut6" @click="moveTab(6)">Evaluasi Administrasi, Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut7" @click="moveTab(7)">Undangan Pembuktian Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut9" @click="moveTab(9)">Penetapan Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut10" @click="moveTab(10)">Pengumuman Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut11" @click="moveTab(11)">Masa Sanggah</v-tab>
          <v-tab v-if="includeTabProses.urut13" @click="moveTab(13)">Undangan Klarifikasi dan Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut14" @click="moveTab(14)">Klarifikasi Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut15" @click="moveTab(15)">Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut16" @click="moveTab(16)">Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
          <v-tab @click="moveTab(17)">Penandatanganan Dokumen Kontrak (SPK) / Perjanjian</v-tab>
          <v-tab @click="moveTab(18)">Penandatanganan Surat Perintah Mulai Kerja (SPMK) / Surat Pesanan</v-tab>
        </template>
        <!-- Pascakualifikasi 2 File -->
        <template v-else-if="paket.kualifikasi === 'K2'">
          <v-tab v-if="includeTabProses.urut1" @click="moveTab(1)">Pengumuman Tender</v-tab>
          <v-tab v-if="includeTabProses.urut2" @click="moveTab(2)">Pendaftaran Dan Pengambilan Dokumen</v-tab>
          <v-tab v-if="includeTabProses.urut3" @click="moveTab(3)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut4" @click="moveTab(4)">Pemasukan Dokumen Penawaran Administrasi Dan Teknis (file 1)</v-tab>
          <v-tab v-if="includeTabProses.urut5" @click="moveTab(5)">Pembukaan Dokumen Penawaran Administrasi Dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut6" @click="moveTab(6)">Evaluasi Dokumen Administrasi Dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut7" @click="moveTab(7)">Undangan Pembuktian Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut8" @click="moveTab(8)">Pengumuman Hasil Evaluasi Administrasi dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut9" @click="moveTab(9)">Pemasukan Dokumen Penawaran Harga (file 2)</v-tab>
          <v-tab v-if="includeTabProses.urut10" @click="moveTab(10)">Pembukaan Dokumen Penawaran Harga</v-tab>
          <v-tab v-if="includeTabProses.urut11" @click="moveTab(11)">Evaluasi Dokumen Penawaran Harga</v-tab>
          <v-tab v-if="includeTabProses.urut12" @click="moveTab(12)">Penetapan Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut13" @click="moveTab(13)">Pengumuman Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut14" @click="moveTab(14)">Masa Sanggah</v-tab>
          <v-tab v-if="includeTabProses.urut15" @click="moveTab(15)">Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)</v-tab>
          <v-tab v-if="includeTabProses.urut17" @click="moveTab(17)">Undangan Klarifikasi Negosiasi Teknis Dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut18" @click="moveTab(18)">Klarifikasi Negosiasi Teknis Dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut19" @click="moveTab(19)">Berita Acara Klarifikasi Negosiasi Teknis Dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut20" @click="moveTab(20)">Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
          <v-tab @click="moveTab(21)">Penandatanganan Kontrak (spk)/perjanjian</v-tab>
          <v-tab @click="moveTab(22)">Penandatanganan Perintah Mulai Kerja / Surat Pesanan</v-tab>
        </template>
      </template> 
      <!-- SELEKSI -->
      <template v-else-if="paket.metodePemilihan === 'SEL' && paket.statusPelaksanaan != 'N'">
        <!-- Prakualifikasi -->
        <template v-if="paket.kualifikasi === 'P'">
          <v-tab v-if="includeTabProses.urut1" @click="moveTab(1)">Pengumuman Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut2" @click="moveTab(2)">Pendaftaran dan Pengambilan Dokumen Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut3" @click="moveTab(3)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut4" @click="moveTab(4)">Pemasukan Dokumen Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut5" @click="moveTab(5)">Pembukaan Dokumen Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut6" @click="moveTab(6)">Evaluasi Dokumen Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut7" @click="moveTab(7)">Undangan Pembuktian Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut9" @click="moveTab(9)">Penetapan Hasil Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut10" @click="moveTab(10)">Pengumuman Hasil Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut11" @click="moveTab(11)">Masa Sanggah Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut13" @click="moveTab(13)">Undangan Tender</v-tab>
          <v-tab v-if="includeTabProses.urut14" @click="moveTab(14)">Pendaftaran dan Pengambilan Dokumen Tender</v-tab>
          <v-tab v-if="includeTabProses.urut15" @click="moveTab(15)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut16" @click="moveTab(16)">Pemasukan Dokumen Penawaran Administrasi dan Teknis (File 1)</v-tab>
          <v-tab v-if="includeTabProses.urut17" @click="moveTab(17)">Pembukaan Dokumen Penawaran Administrasi dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut18" @click="moveTab(18)">Evaluasi Dokumen Penawaran Administrasi dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut19" @click="moveTab(19)">Undangan Pembuktian Dokumen Administrasi dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut20" @click="moveTab(20)">Pengumuman Hasil Evaluasi Administrasi dan Teknis</v-tab>
          <v-tab v-if="includeTabProses.urut21" @click="moveTab(21)">Pemasukan Dokumen Penawaran Biaya (File 2)</v-tab>
          <v-tab v-if="includeTabProses.urut22" @click="moveTab(22)">Pembukaan Dokumen Penawaran Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut23" @click="moveTab(23)">Evaluasi Dokumen Penawaran Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut24" @click="moveTab(24)">Penetapan Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut25" @click="moveTab(25)">Pengumuman Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut26" @click="moveTab(26)">Masa Sanggah</v-tab>
          <!-- <v-tab v-if="includeTabProses.urut27" @click="moveTab(27)">Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)</v-tab> -->
          <v-tab v-if="includeTabProses.urut29" @click="moveTab(29)">Undangan Klarifikasi Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut30" @click="moveTab(30)">Klarifikasi Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut30" @click="moveTab(30)">Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut31" @click="moveTab(31)">Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
          <v-tab @click="moveTab(32)">Penandatanganan Kontrak (SPK) / Perjanjian</v-tab>
          <v-tab @click="moveTab(34)">Penandatanganan Perintah Mulai Kerja (SPMK) / Surat Pesanan</v-tab>
        </template>
        <!-- Pascakualifikasi -->
        <template v-else-if="paket.kualifikasi === 'K'">
          <v-tab v-if="includeTabProses.urut1" @click="moveTab(1)">Pengumuman Tender</v-tab>
          <v-tab v-if="includeTabProses.urut2" @click="moveTab(2)">Pendaftaran dan Pengambilan Dokumen</v-tab>
          <v-tab v-if="includeTabProses.urut3" @click="moveTab(3)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut4" @click="moveTab(4)">Pemasukan Dokumen Penawaran</v-tab>
          <v-tab v-if="includeTabProses.urut5" @click="moveTab(5)">Pembukaan Dokumen Penawaran</v-tab>
          <v-tab v-if="includeTabProses.urut6" @click="moveTab(6)">Evaluasi Administrasi, Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut7" @click="moveTab(7)">Undangan Pembuktian Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut9" @click="moveTab(9)">Penetapan Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut10" @click="moveTab(10)">Pengumuman Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut11" @click="moveTab(11)">Masa Sanggah</v-tab>
          <v-tab v-if="includeTabProses.urut13" @click="moveTab(13)">Undangan Klarifikasi dan Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut14" @click="moveTab(14)">Klarifikasi Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut15" @click="moveTab(15)">Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="includeTabProses.urut16" @click="moveTab(16)">Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
          <v-tab @click="moveTab(17)">Penandatanganan Dokumen Kontrak (SPK) / Perjanjian</v-tab>
          <v-tab @click="moveTab(18)">Penandatanganan Surat Perintah Mulai Kerja (SPMK) / Surat Pesanan</v-tab>
        </template>
      </template>
    </v-tabs>

    <!-- ==================== tab items ===================================================================== -->
    <v-tabs-items v-model="tab">
      <v-tab-item> <LockPage v-if="kunciInformasi"/>
        <PreviewLelang user></PreviewLelang>
      </v-tab-item >   
      <!-- PENUNJUKAN LANGSUNG-->
      <template v-if="paket.metodePemilihan === 'TLA' && paket.statusPelaksanaan != 'N'">
        <v-tab-item v-if="showTabFeature(1)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <UndanganVendor :tipe="'P'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(1)" /> 
          1. Undangan
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(2)"> 
          <ChatMessage tahap="PP" :urut="5" :readonly="readonlyTabFeature(5)" />
          2. Pemberian Penjelasan / Aanwizjing
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(4)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <PembukaanDokumen penawaran /> 
          <Evaluasi 
          kualifikasi
            administrasi
            :bobotTeknis="showBobot()"
            teknis
            :passingGrade="showPSG()"
            nilaiTeknis
            :bobotBiaya="showBobot()"
            :biaya="showBobot()"
            nilaiPenawaran
            :nilaiBiaya="showBobot()"
            :totalNilai="showBobot()"
            pemenang  
            :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(4)" /> 
          4. Pembukaan dan Evaluasi Dokumen Penawaran
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(5)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <UndanganVendor :tipe="'N'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(5)" /> 
          5. Undangan Klarifikasi dan Negosiasi Teknis dan Biaya
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(6)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <HasilNegosiasiTeknisBiaya :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" /> 
          6. Hasil Klarifikasi dan Negosiasi Teknis dan Biaya
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(7)"> <LockPage v-if="kunciProses"/>
          <BaKlarifikasiNegosiasi :vendor="false" :urut="7" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(8)"/> 
          7. Berita Acara Klarifikasi dan Negosiasi
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(8)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <Evaluasi pemenang :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(8)" /> 
          8. Penetapan Penyedia
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(9)"> <LockPage v-if="kunciProses"/>
          <!-- <BaKlarifikasiNegosiasi :vendor="false" :urut="9" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(9)"/>  -->
          <JadwalView :jadwal="paramJadwal"/>
          <!-- TODO -->
          <BeritaAcaraTL />

          9. Berita Acara Penunjukan Langsung
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(10)"> <LockPage v-if="kunciProses"/>
          <Sppbj :vendor="false" :urut="10" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(9)"/> 
          10. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(10)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <SuratPerjanjian spk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(10)" /> 
          11. Surat Perintah Kerja
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(11)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <SuratPerjanjian spmk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(11)" /> 
          12. Surat Perintah Mulai Kerja
        </v-tab-item>
      </template>
      <!-- PENGADAAN LANGSUNG -->
      <template v-else-if="paket.metodePemilihan === 'PLA' && paket.statusPelaksanaan != 'N'">
        <v-tab-item v-if="showTabFeature(1)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <UndanganVendor :tipe="'P'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(1)"/> 
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(2)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <ChatMessage tahap="PP" :urut="2" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(2)" /> 
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(4)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <PembukaanDokumen penawaran :urut="3" :statusPelaksanaan="paket.statusPelaksanaan"/> 
          <Evaluasi 
            kualifikasi
            administrasi
            :bobotTeknis="showBobot()"
            teknis
            :passingGrade="showPSG()"
            nilaiTeknis
            :bobotBiaya="showBobot()"
            :biaya="showBobot()"
            nilaiPenawaran
            :nilaiBiaya="showBobot()"
            :totalNilai="showBobot()"
            pemenang 
            :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" /> 
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(5)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <FilePengumuman :vendor="false" :urut="5"/>
          <Evaluasi 
            kualifikasi 
            administrasi 
            :passingGrade="showPSG()"
            :teknis="showPSG()"
            nilaiTeknis
            nilaiPenawaran
            :totalNilai="showBobot()"
            :nilaiBiaya="showBobot()"
            pemenang 
            readonly /> 
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(6)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <UndanganVendor :tipe="'N'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(5)"/> 
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(6)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <HasilNegosiasiTeknisBiaya :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)"/> 
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(7)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
          <BaKlarifikasiNegosiasi :vendor="false" :urut="7" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/> 
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(9)"> <JadwalView :jadwal="paramJadwal"/>
          <SuratPerjanjian spk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(9)"/> 
        </v-tab-item>
        <v-tab-item v-if="showTabFeature(10)"> <JadwalView :jadwal="paramJadwal"/>
          <SuratPerjanjianSPMK spmk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(10)"/> 
        </v-tab-item>
      </template>
      <!-- TENDER -->
      <template v-else-if="paket.metodePemilihan === 'TEN' && paket.statusPelaksanaan != 'N'">
        <!-- Prakualifikasi -->
        <template v-if="paket.kualifikasi === 'P'">
          <v-tab-item v-if="includeTabProses.urut1"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              1. Pengumuman Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut2"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              2. Pendaftaran dan Pengambilan Dokumen Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut3"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <ChatMessage tahap="PP0" tipe="PP0" :urut="3" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" /> 
              3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut4"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              4. Pemasukan Dokumen Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut5"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PembukaanDokumen kualifikasi /> 
              5. Pembukaan Dokumen Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut6"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi dokumenKualifikasi :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" /> 
              6. Evaluasi Dokumen Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut7"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganVendor :tipe="'B'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)" /> 
              7. Undangan Pembuktian Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut9"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi dokumenKualifikasi kualifikasi :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(9)" />  
              9. Penetapan Hasil Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut10"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="false" :urut="10"/>
              <Evaluasi kualifikasi readonly />
              10. Pengumuman Hasil Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut11"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UserMasaSanggah :vendor="false" :tipe="'P'" :urut="11" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(11)"/> 
              11. Masa Sanggah Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut13"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganLulusKualifikasiP :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(12)" /> 
              13. Undangan Tender
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut14"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
            <h1>View Peserta</h1>
              14. Pendaftaran dan Pengambilan Dokumen Tender
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut15"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <ChatMessage tahap="PP1" tipe="PP1" :urut="15" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(14)" /> 
              15. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut16"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              16. Pemasukan Dokumen Penawaran Administrasi dan Teknis (File 1)
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut17"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PembukaanDokumen administrasi teknis /> 
              17. Pembukaan Dokumen Penawaran Administrasi dan Teknis (File 1)
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut18"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi administrasi bobotTeknis teknis nilaiTeknis :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(17)" /> 
              18. Evaluasi Dokumen Penawaran Administrasi dan Teknis
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut19"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganVendor :tipe="'B2'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)" />
              <br>
              <h3>Evaluasi Dokumen Penawaran Administrasi dan Teknis</h3>
              <br>    
              <Evaluasi administrasi bobotTeknis teknis nilaiTeknis :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(17)" /> 
              19. Undangan Pembuktian Dokumen Administrasi dan Teknis
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut20"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="false" :urut="20"/>
              <Evaluasi administrasi nilaiTeknis readonly /> 
              20. Pengumuman Hasil Evaluasi Administrasi dan Teknis
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut21"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              21. Pemasukan Dokumen Penawaran Harga (File 2)
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut22"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PembukaanDokumen harga /> 
              22. Pembukaan Dokumen Penawaran Harga
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut23"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi nilaiTeknis bobotBiaya nilaiPenawaran biaya nilaiBiaya totalNilai :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(23)" /> 
              23. Evaluasi Dokumen Penawaran Harga
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut24"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi administrasi nilaiTeknis bobotBiaya nilaiPenawaran biaya nilaiBiaya totalNilai pemenang :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(24)" /> 
              24. Penetapan Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut25"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="false" :urut="25"/>
              <Evaluasi administrasi nilaiTeknis nilaiPenawaran nilaiBiaya totalNilai pemenang readonly/> 
              25. Pengumuman Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut26"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UserMasaSanggah :vendor="false" :tipe="'B'" :urut="11" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(26)"/> 
              26. Masa Sanggah
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut27"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UserMasaSanggah :vendor="false" :tipe="'BD'" :urut="11" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(27)"/> 
              27. Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut29"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganVendor :tipe="'N'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(21)" /> 
              29. Undangan Klarifikasi Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut30"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <HasilNegosiasiTeknisBiaya :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(22)" /> 
              30. Klarifikasi Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut31"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <BaKlarifikasiNegosiasi :vendor="false" :urut="31" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/> 
              31. Berita Acara Klarifikasi Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut32"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Sppbj :vendor="false" :urut="14" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/> 
              32. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
          </v-tab-item>
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>
              <SuratPerjanjian spk/> 
              33. Penandatanganan Kontrak (SPK) / Perjanjian
          </v-tab-item>
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>
              <SuratPerjanjian spmk/>
              34. Penandatanganan Perintah Mulai Kerja (SPMK) / Surat Pesanan
          </v-tab-item>
        </template>
        <!-- Pascakualifikasi 1 File -->
        <template v-else-if="paket.kualifikasi === 'K'">
          <v-tab-item v-if="includeTabProses.urut1"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <h1>View Peserta</h1>
              1. Pengumuman Tender
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut2"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <h1>View Peserta</h1>
              2. Pendaftaran dan Pengambilan Dokumen
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut3"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <ChatMessage tahap="PP" :urut="3" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" />
              3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut4"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <h1>View Peserta</h1>
              4. Pemasukan Dokumen Penawaran
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut5"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PembukaanDokumen kualifikasi administrasi teknis harga />
              5. Pembukaan Dokumen Penawaran
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut6"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi kualifikasi administrasi bobotTeknis teknis nilaiTeknis bobotBiaya biaya nilaiPenawaran nilaiBiaya totalNilai :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" />   
              6. Evaluasi Administrasi, Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut7"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <UndanganVendor :tipe="'B'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)" />
              <br>
              <h3>Evaluasi Administrasi, Teknis dan Biaya</h3>
              <br>
              <Evaluasi kualifikasi administrasi bobotTeknis teknis nilaiTeknis bobotBiaya biaya nilaiPenawaran nilaiBiaya totalNilai :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" />   
              7. Undangan Pembuktian Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut9"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi kualifikasi administrasi bobotTeknis teknis nilaiTeknis bobotBiaya biaya nilaiPenawaran nilaiBiaya totalNilai pemenang :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" />   
              9. Penetapan Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut10"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <FilePengumuman :vendor="false" :urut="10"/>
              <Evaluasi kualifikasi administrasi nilaiTeknis nilaiPenawaran nilaiBiaya totalNilai pemenang readonly />  
              10. Pengumuman Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut11"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UserMasaSanggah :vendor="false" :tipe="'B'" :urut="7" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/>  
              11. Masa Sanggah
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut13"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganVendor :tipe="'N'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(13)" />  
              13. Undangan Klarifikasi dan Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut14"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <HasilNegosiasiTeknisBiaya :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(22)" /> 
              14. Klarifikasi Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut15"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <BaKlarifikasiNegosiasi :vendor="false" :urut="15" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/>
              15. Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut16"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <Sppbj :vendor="false" :urut="16" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/>
              16. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
          </v-tab-item>
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>
              <SuratPerjanjian spk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(17)" />  
              17. Penandatanganan Dokumen Kontrak (SPK) / Perjanjian
          </v-tab-item>
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>
              <SuratPerjanjian spmk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(18)" />
              18. Penandatanganan Surat Perintah Mulai Kerja (SPMK) / Surat Pesanan
          </v-tab-item>
        </template>
        <!-- Pascakualifikasi 2 File -->
        <template v-else-if="paket.kualifikasi === 'K2'">
          <v-tab-item v-if="includeTabProses.urut1"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              1. Pengumuman Tender
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut2"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              2. Pendaftaran Dan Pengambilan Dokumen
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut3"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <ChatMessage tahap="PP" :vendor="false" :urut="3" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" />
              3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut4"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              4. Pemasukan Dokumen Penawaran Administrasi Dan Teknis (file 1)
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut5"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PembukaanDokumen kualifikasi administrasi teknis />
              5. Pembukaan Dokumen Penawaran Administrasi Dan Teknis
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut6"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi kualifikasi administrasi bobotTeknis teknis nilaiTeknis :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" />
              6. Evaluasi Dokumen Administrasi Dan Teknis
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut7"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganVendor :tipe="'B'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(12)" /> 
              <br>
              <h3>Evaluasi Dokumen Administrasi Dan Teknis</h3>
              <br>
              <Evaluasi kualifikasi administrasi bobotTeknis teknis nilaiTeknis :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" />
              7. Undangan Pembuktian Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut8"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="false" :urut="9"/>
              <Evaluasi administrasi nilaiTeknis readonly /> 
              8. Pengumuman Peserta Lulus Evaluasi Administrasi Dan Teknis
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut9"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              9. Pemasukan Dokumen Penawaran Harga (file 2)
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut10"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PembukaanDokumen harga />
              10. Pembukaan Dokumen Penawaran Harga
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut11"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi nilaiTeknis bobotBiaya nilaiPenawaran biaya nilaiBiaya totalNilai :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(11)" /> 
              11. Evaluasi Dokumen Penawaran Harga
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut12"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi nilaiTeknis bobotBiaya nilaiPenawaran biaya nilaiBiaya totalNilai pemenang :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(12)" /> 
              12. Penetapan Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut13"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="false" :urut="13"/>
              <Evaluasi administrasi nilaiTeknis nilaiPenawaran nilaiBiaya totalNilai pemenang readonly/>
              13. Pengumuman Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut14"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UserMasaSanggah :vendor="false" :tipe="'B'" :urut="15" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(15)"/>  
              14. Masa Sanggah
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut15"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UserMasaSanggah :vendor="false" :tipe="'BD'" :urut="16" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(16)"/> 
              15. Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut17"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganVendor :tipe="'N'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(18)" /> 
              17. Undangan Klarifikasi Negosiasi Teknis Dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut18"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <HasilNegosiasiTeknisBiaya :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(19)" /> 
              18. Klarifikasi Negosiasi Teknis Dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut19"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <BaKlarifikasiNegosiasi :vendor="false" :urut="19" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(19)"/>
              19. Berita Acara Klarifikasi Negosiasi Teknis Dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut20"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Sppbj :vendor="false" :urut="20" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(20)"/>
              20. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
          </v-tab-item>
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>
              <SuratPerjanjian spk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(21)" />  
              21. Penandatanganan Kontrak (spk)/perjanjian
          </v-tab-item>
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>
              <SuratPerjanjian spmk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(22)" />
              22. Penandatanganan Perintah Mulai Kerja / Surat Pesanan
          </v-tab-item>
        </template>
      </template>
      <!-- SELEKSI -->
      <template v-else-if="paket.metodePemilihan === 'SEL' && paket.statusPelaksanaan != 'N'">
        <!-- Prakualifikasi -->
        <template v-if="paket.kualifikasi === 'P'">
          <v-tab-item v-if="includeTabProses.urut1"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              1. Pengumuman Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut2"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              2. Pendaftaran dan Pengambilan Dokumen Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut3"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <ChatMessage tahap="PP0" tipe="PP0" :urut="3" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" /> 
              3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut4"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              4. Pemasukan Dokumen Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut5"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PembukaanDokumen kualifikasi /> 
              5. Pembukaan Dokumen Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut6"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi dokumenKualifikasi :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" /> 
              6. Evaluasi Dokumen Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut7"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganVendor :tipe="'B'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)" /> 
              7. Undangan Pembuktian Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut9"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi dokumenKualifikasi kualifikasi :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(9)" />  
              9. Penetapan Hasil Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut10"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="false" :urut="10"/>
              <Evaluasi kualifikasi readonly />
              10. Pengumuman Hasil Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut11"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UserMasaSanggah :vendor="false" :tipe="'P'" :urut="11" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(11)"/> 
              11. Masa Sanggah Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut13"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganLulusKualifikasiP :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(12)" /> 
              13. Undangan Tender
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut14"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
            <h1>View Peserta</h1>
              14. Pendaftaran dan Pengambilan Dokumen Tender
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut15"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <ChatMessage tahap="PP1" tipe="PP1" :urut="15" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(14)" /> 
              15. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut16"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              16. Pemasukan Dokumen Penawaran Administrasi dan Teknis (File 1)
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut17"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PembukaanDokumen administrasi teknis /> 
              17. Pembukaan Dokumen Penawaran Administrasi dan Teknis (File 1)
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut18"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi administrasi bobotTeknis teknis nilaiTeknis :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(18)" /> 
              18. Evaluasi Dokumen Penawaran Administrasi dan Teknis
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut19"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganVendor :tipe="'B2'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)" />
              <br>
              <h3>Evaluasi Dokumen Penawaran Administrasi dan Teknis</h3>
              <br>    
              <Evaluasi administrasi bobotTeknis teknis nilaiTeknis :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(17)" /> 
              19. Undangan Pembuktian Dokumen Administrasi dan Teknis
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut20"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="false" :urut="20"/>
              <Evaluasi administrasi nilaiTeknis readonly /> 
              20. Pengumuman Hasil Evaluasi Administrasi dan Teknis
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut21"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <h1>View Peserta</h1>
              21. Pemasukan Dokumen Penawaran Biaya (File 2)
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut22"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PembukaanDokumen harga /> 
              22. Pembukaan Dokumen Penawaran Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut23"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi nilaiTeknis bobotBiaya nilaiPenawaran biaya nilaiBiaya totalNilai :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(23)" /> 
              23. Evaluasi Dokumen Penawaran Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut24"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi nilaiTeknis bobotBiaya nilaiPenawaran biaya nilaiBiaya totalNilai pemenang :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(24)" /> 
              24. Penetapan Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut25"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="false" :urut="25"/>
              <Evaluasi administrasi nilaiTeknis nilaiPenawaran nilaiBiaya totalNilai pemenang readonly/> 
              25. Pengumuman Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut26"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UserMasaSanggah :vendor="false" :tipe="'B'" :urut="11" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(26)"/> 
              26. Masa Sanggah
          </v-tab-item>
          <!-- <v-tab-item v-if="includeTabProses.urut27"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UserMasaSanggah :vendor="false" :tipe="'BD'" :urut="23" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(27)"/> 
              27. Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)
          </v-tab-item> -->
          <v-tab-item v-if="includeTabProses.urut29"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganVendor :tipe="'N'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(21)" /> 
              29. Undangan Klarifikasi Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut30"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <HasilNegosiasiTeknisBiaya :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(22)" /> 
              30. Klarifikasi Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut31"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <BaKlarifikasiNegosiasi :vendor="false" :urut="31" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/> 
              31. Berita Acara Klarifikasi Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut32"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Sppbj :vendor="false" :urut="14" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/> 
              32. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
          </v-tab-item>
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>
              <SuratPerjanjian spk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(28)" /> 
              33. Penandatanganan Kontrak (SPK) / Perjanjian
          </v-tab-item>
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>
              <SuratPerjanjian spmk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(29)" />
              34. Penandatanganan Perintah Mulai Kerja (SPMK) / Surat Pesanan
          </v-tab-item>
        </template>
        <!-- Pascakualifikasi -->
        <template v-else-if="paket.kualifikasi === 'K'">
          <v-tab-item v-if="includeTabProses.urut1"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <h1>View Peserta</h1>
              1. Pengumuman Tender
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut2"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <h1>View Peserta</h1>
              2. Pendaftaran dan Pengambilan Dokumen
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut3"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <ChatMessage tahap="PP" :urut="3" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" />
              3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut4"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <h1>View Peserta</h1>
              4. Pemasukan Dokumen Penawaran
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut5"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PembukaanDokumen kualifikasi administrasi teknis harga />
              5. Pembukaan Dokumen Penawaran
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut6"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi kualifikasi administrasi bobotTeknis teknis nilaiTeknis bobotBiaya biaya nilaiPenawaran nilaiBiaya totalNilai :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" />   
              6. Evaluasi Administrasi, Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut7"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <UndanganVendor :tipe="'B'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)" />
              <br>
              <h1>Evaluasi Administrasi, Teknis dan Biaya</h1>
              <br>
              <Evaluasi kualifikasi administrasi bobotTeknis teknis nilaiTeknis bobotBiaya biaya nilaiPenawaran nilaiBiaya totalNilai :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" />   
              7. Undangan Pembuktian Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut9"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi kualifikasi administrasi bobotTeknis teknis nilaiTeknis bobotBiaya biaya nilaiPenawaran nilaiBiaya totalNilai pemenang :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(9)" />   
              9. Penetapan Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut10"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <FilePengumuman :vendor="false" :urut="10"/>
              <Evaluasi kualifikasi administrasi nilaiTeknis nilaiPenawaran nilaiBiaya totalNilai pemenang readonly />  
              10. Pengumuman Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut11"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UserMasaSanggah :vendor="false" :tipe="'B'" :urut="7" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/>  
              11. Masa Sanggah
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut13"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <UndanganVendor :tipe="'N'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(13)" />  
              13. Undangan Klarifikasi dan Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut14"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <HasilNegosiasiTeknisBiaya :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(22)" /> 
              14. Klarifikasi Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut15"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <BaKlarifikasiNegosiasi :vendor="false" :urut="15" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/>
              15. Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut16"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
              <Sppbj :vendor="false" :urut="16" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(7)"/>
              16. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
          </v-tab-item>
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>
              <SuratPerjanjian spk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(17)" />  
              17. Penandatanganan Dokumen Kontrak (SPK) / Perjanjian
          </v-tab-item>
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>
              <SuratPerjanjian spmk :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(18)" />
              18. Penandatanganan Surat Perintah Mulai Kerja (SPMK) / Surat Pesanan
          </v-tab-item>
        </template>
      </template>
    </v-tabs-items>      
  </div>
</template>

<script>
const apiUrl = process.env.VUE_APP_ROOT_API
import axios from "axios";
import PreviewLelang from './PreviewLelang'
//--
  //import UndangVendor from './PengadaanLangsung/UndangVendor'
  //import AllPenawaranPL from './PengadaanLangsung/AllPenawaranPL'
  //import EvaluasiPL from './PengadaanLangsung/EvaluasiPL'
  // import BeritaAcaraPL from './PengadaanLangsung/BeritaAcaraPL'
//--
import ChatMessage from "./ChatMessage"
//--
  // Pascakualifikasi
  //import DownloadPenawaranK1 from "./PascaKualifikasi/UserDownloadPenawaranK1"
  //import DownloadPenawaranK2 from "./PascaKualifikasi/UserDownloadPenawaranK2"
  //import EvaluasiAdministrasiTeknisBiayaK1 from "./PascaKualifikasi/UserEvaluasiAdministrasiTeknisBiayaK1"
  //import EvaluasiAdministrasiKualifikasiK2 from "./PascaKualifikasi/UserEvaluasiAdministrasiKualifikasiK2"
  //import EvaluasiTeknisK2 from "./PascaKualifikasi/UserEvaluasiTeknisK2"
  //import DownloadHargaK2 from "./PascaKualifikasi/UserDownloadHargaK2"
  //import EvaluasiHargaK2 from "./PascaKualifikasi/UserEvaluasiHargaK2"
  //import UndanganPembuktianKualifikasiK from "./PascaKualifikasi/UserUndanganPembuktianKualifikasi"
  //import UndanganKlarifikasiNegosiasiK from "./PascaKualifikasi/UserUndanganKlarifikasiNegosiasi"
  //import HasilNegosiasiK from "./PascaKualifikasi/UserHasilNegosiasi"
  //import PenetapanPemenangK from "./PascaKualifikasi/UserPenetapanPemenang"
  //import BeritaAcaraK from "./PascaKualifikasi/BeritaAcara"
//--

// Prakualifikasi
//import DownloadDokumenKualifikasiP from "./Prakualifikasi/UserDownloadDokumenKualifikasi"
//import EvaluasiDokumenKualifikasiP from "./Prakualifikasi/UserEvaluasiDokumenKualifikasi"
//import UndanganPembuktianKualifikasiP from "./Prakualifikasi/UserUndanganPembuktianKualifikasi"
//import PenetapanHasilKualifikasiP from "./Prakualifikasi/UserPenetapanHasilKualifikasi"
import UndanganLulusKualifikasiP from "./Prakualifikasi/UserUndanganLulusKualifikasi"
//--
  //import DownloadPenawaranAdministrasiTeknisP from "./Prakualifikasi/UserDownloadPenawaranAdministrasiTeknis"
  //import EvaluasiPenawaranAdministrasiTeknisP from "./Prakualifikasi/UserEvaluasiPenawaranAdministrasiTeknis"
  //import DownloadPenawaranHargaP from "./Prakualifikasi/UserDownloadPenawaranHarga"
  //import EvaluasiPenawaranHargaP from "./Prakualifikasi/UserEvaluasiPenawaranHarga"
  //import PenetapanPemenangP from "./Prakualifikasi/UserPenetapanPemenang"
  //import UndanganKlarifikasiNegosiasiBiayaP from "./Prakualifikasi/UserUndanganKlarifikasiNegosiasiBiaya"
  //import HasilNegosiasiTeknisBiayaP from "./Prakualifikasi/UserHasilNegosiasiTeknisBiaya"
  //import BeritaAcaraP from "./Prakualifikasi/BeritaAcara"

  // Penunjukan Langsung
  //import UndangVendorTL from "./PenunjukanLangsung/UserUndangan"
  //import UndanganPembuktianKualifikasiTL from "./PenunjukanLangsung/UserUndanganPembuktianKualifikasi"
  //import PembukaanEvaluasiDokumenPenawaranTL from "./PenunjukanLangsung/UserPembukaanEvaluasiDokumenPenawaran"
  //import UndanganNegosiasiTeknisBiayaTL from "./PenunjukanLangsung/UserUndanganNegosiasiTeknisBiaya"
  //import HasilNegosiasiTeknisBiayaTL from "./PenunjukanLangsung/UserHasilNegosiasiTeknisBiaya"
  //import PenetapanPenyediaTL from "./PenunjukanLangsung/UserPenetapanPenyedia"
  import BeritaAcaraTL from "./PenunjukanLangsung/BeritaAcaraTL"
  // import BeritaAcaraKlarifikasiNegosiasiPL from "./PengadaanLangsung/BeritaAcaraKlarifikasiNegosiasiPL"
//--
import BaKlarifikasiNegosiasi from "./BaKlarifikasiNegosiasi"
import UserMasaSanggah from "./UserMasaSanggah"
import Sppbj from "./Sppbj"
import FilePengumuman from "./FilePengumuman"
import UndanganVendor from "./UserUndanganVendor"
import PembukaanDokumen from "./UserPembukaanDokumen"
import Evaluasi from "./Evaluasi"
import HasilNegosiasiTeknisBiaya from "./UserHasilNegosiasiTeknisBiaya"
import SuratPerjanjian from "./UserSuratPerjanjian"
import SuratPerjanjianSPMK from "./UserSuratPerjanjianSPMK"
import LockPage from "./LockPage";
import JadwalView from "./JadwalView";
import { format, parseISO } from 'date-fns';

export default {
  components: {
    LockPage,
    JadwalView,
    PreviewLelang, 
    //--
    //UndangVendor, 
    //AllPenawaranPL, 
    //EvaluasiPL, 
    // BeritaAcaraPL,
    //--
    ChatMessage, 
    UndanganVendor,
    PembukaanDokumen,
    Evaluasi,
    HasilNegosiasiTeknisBiaya,
    SuratPerjanjian,
    SuratPerjanjianSPMK,
    //--
    // Prakualifikasi
    //DownloadDokumenKualifikasiP,
    //EvaluasiDokumenKualifikasiP,
    //UndanganPembuktianKualifikasiP,
    //PenetapanHasilKualifikasiP,
    //--
    UndanganLulusKualifikasiP,
    //--
    //DownloadPenawaranAdministrasiTeknisP,
    //EvaluasiPenawaranAdministrasiTeknisP,
    //DownloadPenawaranHargaP,
    //EvaluasiPenawaranHargaP,
    //PenetapanPemenangP,
    //UndanganKlarifikasiNegosiasiBiayaP,
    //HasilNegosiasiTeknisBiayaP,
    //BeritaAcaraP,

    // Pascakualifikasi
    //DownloadPenawaranK1,
    //DownloadPenawaranK2, 
    //EvaluasiAdministrasiTeknisBiayaK1, 
    //EvaluasiAdministrasiKualifikasiK2, 
    //EvaluasiTeknisK2,
    //DownloadHargaK2, 
    //EvaluasiHargaK2, 
    //UndanganPembuktianKualifikasiK, 
    //UndanganKlarifikasiNegosiasiK,
    //HasilNegosiasiK, 
    //PenetapanPemenangK, 
    //BeritaAcaraK, 

    // Penunjukan Langsung
    //UndangVendorTL,
    //UndanganPembuktianKualifikasiTL,
    //PembukaanEvaluasiDokumenPenawaranTL,
    //UndanganNegosiasiTeknisBiayaTL,
    //HasilNegosiasiTeknisBiayaTL,
    //PenetapanPenyediaTL,
    BeritaAcaraTL,
    // BeritaAcaraKlarifikasiNegosiasiPL,
    //--
    BaKlarifikasiNegosiasi,
    UserMasaSanggah,
    Sppbj,
    FilePengumuman
  },

  computed: {
    paket: function() {
      return this.$store.getters['lelang/paket']
    },
    jadwal: function() {
      return this.$store.getters['lelang/jadwal']
    },
    userId: function() {
      return this.$store.getters['userInfo'].userId;
    }
  },

  watch: {
    paket() {}
  },

  data() {
    return {
      tab: null,
      serverTime: null,
      checkJadwal: false,
      paramJadwal: "",
      kunciProses: false,
      kunciInformasi: false,
      includeTabProses:{
          urut1: false,
          urut2: false,
          urut3: false,
          urut4: false,
          urut5: false,
          urut6: false,
          urut7: false,
          urut8: false,
          urut9: false,
          urut10: false,
          urut11: false,
          urut12: false,
          urut13: false,
          urut14: false,
          urut15: false,
          urut16: false,
          urut17: false,
          urut18: false,
          urut19: false,
          urut20: false,
          urut21: false,
          urut22: false,
          urut23: false,
          urut24: false,
          urut25: false,
          urut26: false,
          urut27: false,
          urut28: false,
          urut29: false,
          urut30: false,
          urut31: false,
          urut32: false,
          urut33: false,
          urut34: false,
          urut35: false,
          urut36: false,
          urut37: false,
          urut38: false,
          urut39: false,
          urut40: false
      }
    }
  },

  mounted() {    
    if(this.paket.statusPelaksanaan == 'S') {
        this.kunciInformasi = true;
    }
    this.forceIncludeTabProses();
  },

  methods: {
    showTabFeature(urut) {
      const check = this.jadwal.find(element => element.include && element.urut == urut);
      if (check == null) return false;
      if (!this.checkJadwal) return true;
      const bShow = check && Date.parse(this.serverTime) >= Date.parse(check.mulai);
      console.log("Show Tab Feature: ", urut, bShow);
      return bShow;
    },
    showPSG() {
      return this.paket.metodeEvaluasi == 'RENPSG' || this.paket.metodeEvaluasi == 'NILPSG' ? true : false;
    },
    showBobot() {
      return this.paket.metodeEvaluasi == 'REN' || this.paket.metodeEvaluasi == 'RENPSG' ? false : true;
    },
    readonlyTabFeature(urut) {
      if (!this.checkJadwal) return false;
      const check = this.jadwal.find(element => element.include && element.urut == urut);
      const bReadOnly = check && Date.parse(check.selesai) < Date.parse(this.serverTime); 
      // console.log("Readonly Tab Feature: ", urut, bReadOnly, new Date(check.selesai), new Date(this.serverTime));
      return bReadOnly;
    },
    async moveTab(urut) {
        await axios.get(`${apiUrl}/api/time`)
        .then( (response) => {
          this.serverTime = response.data.time;
        })
        .catch( (error) => {
          console.error(error);
        });
        let objJadwal = this.jadwal.find(el => el.urut === urut);
        this.paramJadwal = this.getDateFormattedDatefnsMinute(objJadwal.mulai) +" - "+ this.getDateFormattedDatefnsMinute(objJadwal.selesai);
        
        const nowDate = new Date(this.getDateFormattedDatefnsMinute(this.serverTime));
        const startDateTime = new Date(this.getDateFormattedDatefnsMinute(objJadwal.mulai));
        const endDateTime = new Date(this.getDateFormattedDatefnsMinute(objJadwal.selesai));
        if(this.paket.statusPelaksanaan !== 'A') {
            this.kunciProses = true;
        }else if(nowDate >= startDateTime && nowDate <= endDateTime) {
            this.kunciProses = false;
        }else {
            this.kunciProses = true;
        }
    },
    getDateFormattedDatefnsMinute: function(date) {
        return date ? format(parseISO(date), "dd MMM yyyy HH:mm") : '';
    },

    forceIncludeTabProses() {
        this.jadwal.forEach(element => {
            this.includeTabProses['urut'+element.urut] = element.include;
        });
    }
  }

}
</script>

<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
</style>